module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0009.064a9dbf.jpg";